import {
  compose,
  pure,
  lifecycle,
  withHandlers,
  defaultProps,
  renameProp,
} from 'recompose'
import * as R from 'ramda'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

const enhance = compose(
  defaultProps({
    onChange: R.identity,
  }),
  renameProp('onChange', 'onChangeCallback'),
  toReduxFormField('InputTextArea'),
  withHandlers({
    handleChange:
      ({ input: { onChange }, onChangeCallback }) =>
      e => {
        onChange(e.target.value)
        onChangeCallback(e.target.value)
      },
  }),
  lifecycle({
    componentDidMount() {
      this.props.input.onChange(this.props.input.value)
    },
  }),
  pure,
)

export default enhance
